import FreespinPromptController from "../../controllers/freespin/FreespinPromptController";
import MainGridController from "../../controllers/grid/MainGridController";
import { COMPONENTS } from "../../lib/constants";
import { FreespinPromptGrid } from "./FreespinPromptGrid";

export const FreespinPromptView = {
  name: COMPONENTS.FREESPIN_PROMPT,
  child: true,
  zIndex: 2,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: FreespinPromptController,
      name: "FreespinPromptController",
      config: {
        holder: "freespin_prompt_holder",
      },
    },
    {
      Controller: MainGridController,
      name: "PromptGridController",
      config: FreespinPromptGrid,
    },
  ],
  components: [
    {
      name: "freespin_prompt_holder",
      type: "Sprite",
      components: [
        {
          name: "bg",
          type: "Sprite",
          img: "dialog_main_bg",
          position: { x: 0, y: 0 },
        },
        {
          name: "bg_border",
          type: "Sprite",
          img: "sm_modal_frame",
          position: { x: -20, y: -20 },
        },
        {
          name: "header",
          type: "Text",
          text: "FREE_SPIN_HEADER",
          position: { x: 587 / 2, y: 30 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "FREE_SPIN_TIME_FRAME_WRAPPER",
          type: "Sprite",
          position: {
            x: 444,
            y: 85,
          },
          components: [
            {
              name: "FREE_SPIN_TIME_FRAME",
              type: "Sprite",
              img: "time_frame",
              position: {
                x: 4,
                y: 0,
              },
              scale: {
                x: 1.5,
                y: 1.5,
              },
            },
            {
              name: "FREE_SPIN_TIME_TEXT",
              type: "Text",
              text: "FREE_SPIN_TIME_TEXT",
              position: { x: 144 / 2, y: 5 },
              anchor: { x: 0.5, y: 0 },
            },
            {
              name: "FREE_SPIN_TIME",
              type: "Text",
              text: "FREE_SPIN_TIME",
              position: { x: 144 / 2, y: 27 },
              anchor: { x: 0.5, y: 0 },
            },
          ],
        },
        {
          name: "FREE_SPIN_TITLE",
          type: "Text",
          text: "FREE_SPIN_TITLE",
          position: { x: 587 / 2, y: 140 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "FREE_SPIN_PRIZE",
          type: "Text",
          text: "FREE_SPIN_PRIZE",
          position: { x: 587 / 2 + 10, y: 180 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "FREE_SPIN_INFO",
          type: "Text",
          text: "FREE_SPIN_INFO",
          position: { x: 587 / 2, y: 280 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "FREE_SPIN_PLAY_NOW",
          type: "ActionButton",
          bg: "external_bonus_play_now_btn",
          position: { x: 180, y: 395 },
        },
        {
          name: "FREE_SPIN_PLAY_LATER",
          type: "ActionButton",
          bg: "external_bonus_play_later_btn",
          position: { x: 415, y: 395 },
        },
      ],
    },
  ],
};
